import { Component, OnInit, Input, ComponentFactoryResolver, ViewChild, Type, HostListener } from '@angular/core';
import { AbstractTable } from '../table.class';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CellHolderDirective } from '../../../../cells/holders/cell-holder.directive';
import { Fade } from '../../../../../animations/animations';
import { Toggler } from '../../../../../utils/toggler.class';

@Component({
   selector: 'exi-menu-holder',
   template: `
      <ng-template cell-holder></ng-template>
   `,
   styleUrls: ['./menu.component.scss'],
   animations: [
      Fade
   ]
})
export class MenuHolderComponent implements OnInit {
   @Input() public menu: AbstractMenu<any>;
   @ViewChild(CellHolderDirective) private menuHolder: CellHolderDirective;
   @HostListener('window:keyup.esc') onEscape() {
      this.menu.toggler.close();
   }

   public type: string;

   constructor(
      private cmpResolver: ComponentFactoryResolver
   ) { }


   ngOnInit(): void {
      const comp = this.menu.component;
      const factory = this.cmpResolver.resolveComponentFactory(comp);
      const viewRef = this.menuHolder.viewContainerRef;
      const instance = viewRef.createComponent(factory).instance;

      (instance as any).menu = this.menu;
   }

}


export abstract class AbstractMenu<D extends AbstractTable<any>> {
   readonly toggler = new Toggler();
   readonly total: Observable<number>;
   abstract component: Type<any>;

   constructor(
      readonly type: 'local' | 'remote',
      readonly ctx: D,
      readonly filtred: Observable<number>,
   ) {
      this.total = ctx.source.pipe(
         map(rows => rows.length)
      );
   }


}


